//initialize user details
export const userEmployee = [
  {
    employee_id: '',
    role_id: '',
    email: '',
    name: '',
    phone: '',
    user_org_mapping: {
      status: true,
      entity_code: '',
      organisation_code: '',
    },
  },
]
// Initial form values for the login form
export const loginInitialValues = {
  id: '', // Optional user ID (can be used in case of prefilled form or admin login)
  email: '', // Email input field
  password: '', // Password input field
}

// Initial form values for the reset password form (typically after verifying identity)
export const resetInitialValues = {
  id: '', // User ID (optional but useful for identifying the account)
  new_password: '', // New password to set
  confirm_new_password: '', // Confirmation of the new password
}

// Initial form values used when updating password (e.g., from account settings)
export const resetAuthValues = {
  password: '', // Current password
  new_password: '', // New password to set
  confirm_new_password: '', // Confirmation of the new password
}

// Initial form values for the forgot password flow
export const forgotInitial = {
  email: '', // Email address used for sending reset instructions
}
export const chartInitialValue = {
  color: '',
  displayName: '',
  isHidden: false,
  isSortable: false,
  key: '',
  url: '',
  xtitle: '',
  yKey: '',
  yName: '',
}